import React from 'react'
import { connect } from 'react-redux'
import { logout } from '../../store/actions/auth'

function TopNav({ auth, logout }) {
  return (
    <div id='TopNav'>
      <div className='h-100 px-4 row d-flex justify-content-between align-items-center'>
        <div className='col-md-2 fw-bold'>XCBM</div>
        <div className='col-md-1 logout d-flex justify-content-end' onClick={() => logout()}>
          <i className='fas fa-power-off'></i>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = ({ auth }) => ({ auth })

export default connect(mapStateToProps, { logout })(TopNav)
